document.addEventListener("DOMContentLoaded", function () {
  const animatedItems = document.querySelectorAll(".journal-feed__grid--animated .journal-feed__item");

  if (animatedItems.length === 0) return;

  // Intersection Observer for scroll animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px', // Triggers slightly before it comes fully into view
    threshold: 0.05
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add a slight delay based on position for a staggered effect
        const delay = Math.random() * 200; 
        setTimeout(() => {
          entry.target.classList.add("is-visible");
        }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  animatedItems.forEach(item => {
    observer.observe(item);
  });
});
